import React, { Component } from "react";
import { connect } from "react-redux";
import { DatePicker, Select } from "antd";
import moment from "moment";
import styles from "./BalanceUpload.local.scss";
import { setStartDate, setAccountingDates } from "Actions";
import {
  generateAccountingDates,
  recalculateAccountingMonths,
  calculateEventualDiffMonths
} from "Utils";
import { IconContext } from "react-icons";
import { FiMinusSquare, FiPlusSquare } from "react-icons/fi";
import ReactTooltip from "react-tooltip";
import _ from "i18n";
const { Option } = Select;

class BalanceAccountingConfig extends Component {
  // **** BalanceAccountingConfig (functions) ***** //
  handleDateChange = (e, index) => {
    let { accountingDates, startDate } = this.props;
    let dates = [...accountingDates];
    if (index === "startDate") {
      startDate = e.format("YYYY-MM-DD");
      this.props.dispatch(setStartDate(startDate));
    } else {
      dates[index] = {
        accountingDate: e.format("YYYY-MM-DD"),
        months: 12,
        year: Number(e.format("YYYY"))
      };

      this.props.dispatch(setAccountingDates(dates));
    }

    if (
      startDate &&
      dates[0].accountingDate &&
      !dates[0].months &&
      (index === "startDate" || index === 0)
    ) {
      this.props.dispatch(
        setAccountingDates(
          recalculateAccountingMonths(
            startDate,
            generateAccountingDates(startDate, dates[0].accountingDate)
          )
        )
      );
    } else {
      this.props.dispatch(
        setAccountingDates(recalculateAccountingMonths(startDate, dates))
      );
    }
  };

  handleAddAccountingDate = (startDate, accountingDates) => {
    let accounting = [...accountingDates];
    accounting.push({
      accountingDate: moment(
        accountingDates[accountingDates.length - 1].accountingDate,
        "YYYY-MM-DD"
      )
        .add(-1, "year")
        .format("YYYY-MM-DD"),
      months: 12,
      year: accountingDates[accountingDates.length - 1].year - 1
    });

    this.props.dispatch(
      setAccountingDates(recalculateAccountingMonths(startDate, accounting))
    );
  };

  handleAddInTopAccountingDate = (startDate, accountingDates) => {
    let accounting = [
      {
        accountingDate: moment(accountingDates[0].accountingDate, "YYYY-MM-DD")
          .add(+1, "year")
          .format("YYYY-MM-DD"),
        months: 12,
        year: accountingDates[0].year + 1
      },
      ...accountingDates
    ];
    this.props.dispatch(
      setAccountingDates(recalculateAccountingMonths(startDate, accounting))
    );
  };

  handleRemoveAccountingDate = (startDate, accountingDates) => {
    let accounting = [...accountingDates];
    this.props.dispatch(
      setAccountingDates(
        recalculateAccountingMonths(
          startDate,
          accounting.splice(0, accounting.length - 1)
        )
      )
    );
  };

  handleRemoveInTopAccountingDate = (startDate, accountingDates) => {
    let accounting = [...accountingDates];
    this.props.dispatch(
      setAccountingDates(
        recalculateAccountingMonths(
          startDate,
          accounting.splice(1, accounting.length)
        )
      )
    );
  };

  // **** BalanceAccountingConfig (functions) END ***** //

  // **** BalanceAccountingConfig (render) ***** //

  renderInitAccountingDates = accountingDates => {
    let span = [];
    span.push(
      <span className={`columns medium-5 ${styles.accounting_span}`} key={0}>
        <label className={styles.accounting_span__label_for_medium_5}>
          {_("closingDate")} :
        </label>
        <DatePicker
          className={styles.date_picker_ttp}
          showToday={false}
          allowClear={false}
          disabledDate={current => {
            return current && current.valueOf() > Date.now();
          }}
          value={moment(accountingDates[0].accountingDate, "YYYY-MM-DD")}
          onChange={e => this.handleDateChange(e, 0)}
        />
      </span>
    );

    return span;
  };

  renderAccountingDates = (accountingDates, startDate) => {
    let accountingDatesInputs = [];

    accountingDatesInputs.push(
      <span
        className={`columns medium-12 ${styles.add_remove_accounting_span}`}
        key={"add_remove_inTop_accounting_span"}
      >
        <div
          data-for={`addAccountingDate`}
          data-tip={_("addExercise")}
          onClick={() =>
            this.handleAddInTopAccountingDate(startDate, accountingDates)
          }
          className={
            accountingDates[0].year === new Date().getFullYear()
              ? styles.add_remove_accounting_disabled
              : ""
          }
        >
          <IconContext.Provider
            value={{
              style: {
                verticalAlign: "sub",
                fontSize: "17px",
                cursor: "pointer"
              }
            }}
          >
            <FiPlusSquare />
          </IconContext.Provider>
          <ReactTooltip
            id={`addAccountingDate`}
            type="dark"
            place="bottom"
            className={styles.tool_tip}
          />
        </div>
        <div
          data-for={`removeAccountingDate`}
          data-tip={_("removeExercise")}
          onClick={() =>
            this.handleRemoveInTopAccountingDate(startDate, accountingDates)
          }
          className={
            accountingDates.length === 1
              ? styles.add_remove_accounting_disabled
              : ""
          }
        >
          <IconContext.Provider
            value={{
              style: {
                verticalAlign: "sub",
                fontSize: "17px",
                cursor: "pointer",
                marginRight: 33
              }
            }}
          >
            <FiMinusSquare />
          </IconContext.Provider>
          <ReactTooltip
            id={`removeAccountingDate`}
            type="dark"
            place="bottom"
            className={styles.tool_tip}
          />
        </div>
      </span>
    );

    accountingDatesInputs.push(
      <span className="columns medium-5" key={"date"}>
        <label className={styles.accounting_span__label_for_medium_5}>
          {_("closingDate")} :
        </label>
      </span>,
      <span className="columns medium-3" key={"months"}>
        <label className={styles.accounting_span__label_for_medium_3}>
          {_("duration")} :
        </label>
      </span>,
      <span className="columns medium-4" key={"year"}>
        <label className={styles.accounting_span__label_for_medium_4}>
          {_("year")} :
        </label>
      </span>
    );

    // eslint-disable-next-line array-callback-return
    accountingDates.map((item, i) => {
      accountingDatesInputs.push(
        <span
          className={`columns medium-5 ${styles.accounting_span}`}
          key={`date-${i}`}
        >
          <DatePicker
            className={styles.date_picker_ttp}
            showToday={false}
            allowClear={false}
            value={moment(item.accountingDate, "YYYY-MM-DD")}
            disabledDate={current => {
              return (
                (i === 0
                  ? current > moment().endOf("day")
                  : moment(
                      accountingDates[i - 1].accountingDate,
                      "YYYY-MM-DD"
                    ).add(-6, "month") <= current) ||
                (i !== accountingDates.length - 1
                  ? moment(
                      accountingDates[i + 1].accountingDate,
                      "YYYY-MM-DD"
                    ).add(6, "month") >= current
                  : calculateEventualDiffMonths(
                      item.accountingDate,
                      startDate
                    ) > 6
                    ? moment(
                        accountingDates[i - 1]
                          ? accountingDates[i - 1].accountingDate
                          : accountingDates[0].accountingDate,
                        "YYYY-MM-DD"
                      ).add(-18, "month") > current
                    : moment(startDate, "YYYY-MM-DD").add(6, "month") > current)
              );
            }}
            onChange={e => this.handleDateChange(e, i)}
          />
        </span>,
        <span
          className={`columns medium-3 ${styles.accounting_span}`}
          key={`months-${i}`}
        >
          <Select
            value={item.months}
            style={{
              width: 100,
              float: "left",
              top: "0.5rem"
            }}
            disabled
          >
            <Option value={item.months}>{item.months}</Option>
          </Select>
        </span>,
        <span
          className={`columns medium-4 ${styles.accounting_span}`}
          key={`year-${i}`}
        >
          <Select
            value={item.year}
            style={{
              width: 120,
              float: "left",
              top: "0.5rem"
            }}
            disabled
          >
            <Option value={item.year}>{item.year} </Option>
          </Select>
        </span>
      );
    });

    accountingDatesInputs.push(
      <span
        className={`columns medium-12 ${styles.add_remove_accounting_span}`}
        key={"add_remove_accounting_span"}
      >
        <div
          data-for={`addAccountingDate`}
          data-tip={_("addExercise")}
          onClick={() =>
            this.handleAddAccountingDate(startDate, accountingDates)
          }
          className={
            calculateEventualDiffMonths(
              accountingDates[accountingDates.length - 1].accountingDate,
              startDate
            ) < 6
              ? styles.add_remove_accounting_disabled
              : ""
          }
        >
          <IconContext.Provider
            value={{
              style: {
                verticalAlign: "sub",
                fontSize: "17px",
                cursor: "pointer"
              }
            }}
          >
            <FiPlusSquare />
          </IconContext.Provider>
          <ReactTooltip
            id={`addAccountingDate`}
            type="dark"
            place="bottom"
            className={styles.tool_tip}
          />
        </div>
        <div
          data-for={`removeAccountingDate`}
          data-tip={_("removeExercise")}
          onClick={() =>
            this.handleRemoveAccountingDate(startDate, accountingDates)
          }
          className={
            accountingDates.length === 1
              ? styles.add_remove_accounting_disabled
              : ""
          }
        >
          <IconContext.Provider
            value={{
              style: {
                verticalAlign: "sub",
                fontSize: "17px",
                cursor: "pointer",
                marginRight: 33
              }
            }}
          >
            <FiMinusSquare />
          </IconContext.Provider>
          <ReactTooltip
            id={`removeAccountingDate`}
            type="dark"
            place="bottom"
            className={styles.tool_tip}
          />
        </div>
      </span>
    );
    return accountingDatesInputs;
  };

  // **** BalanceAccountingConfig (render) END ***** //

  render() {
    const { accountingDates, startDate } = this.props;
    return (
      <div className="row">
        <span className={`columns medium-12 ${styles.slide_title}`}>
          <h6>
            <b>{_("exercisesConfiguration")} :</b>
          </h6>
        </span>

        {startDate && accountingDates[0] && accountingDates[0].months
          ? this.renderAccountingDates(accountingDates, startDate)
          : this.renderInitAccountingDates(accountingDates)}

        <span className={`columns medium-5 ${styles.accounting_span}`}>
          <label className={styles.accounting_span__label_for_medium_5}>
            {_("companyDateCreation")} :
          </label>
          <DatePicker
            className={styles.date_picker_ttp}
            showToday={false}
            allowClear={false}
            defaultPickerValue={moment(
              accountingDates[0].accountingDate,
              "YYYY-MM-DD"
            ).add(-1, "year")}
            disabledDate={current => {
              return (
                moment(accountingDates[0].accountingDate, "YYYY-MM-DD").add(
                  -0.7,
                  "year"
                ) <= current
              );
            }}
            value={startDate ? moment(startDate, "YYYY-MM-DD") : null}
            onChange={e => this.handleDateChange(e, "startDate")}
          />
        </span>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  accountingDates: state.balance.accountingDates,
  startDate: state.balance.startDate,
  organization: state.balance.organization
});

export default connect(mapStateToProps)(BalanceAccountingConfig);



// WEBPACK FOOTER //
// ./src/components/BalanceUpload/BalanceAccountingConfig.js